import { Reveal } from "@/components/motion/motion";
import { cn } from "@/lib/utils";
import { Overline } from "./SectionHeading";

/** Titled numbered list, used for deliverables and prerequisites. */
export function ListCard({
	label,
	title,
	description,
	items,
	note,
	className,
}: {
	label: string;
	title: string;
	description?: string;
	items: Record<string, string>;
	note?: string;
	className?: string;
}) {
	return (
		<Reveal
			className={cn(
				"flex h-full flex-col rounded-3xl border bg-card p-7 md:p-10",
				className,
			)}
		>
			<Overline>{label}</Overline>
			<h2 className="mt-5 text-3xl leading-tight font-semibold tracking-[-0.03em] text-balance">
				{title}
			</h2>
			{description ? (
				<p className="mt-3 text-pretty text-muted-foreground">{description}</p>
			) : null}
			<ol className="mt-8 flex-1 border-t">
				{Object.entries(items).map(([key, item], index) => (
					<li key={key} className="flex gap-5 border-b py-4">
						<span
							aria-hidden="true"
							className="w-6 shrink-0 pt-0.5 font-mono text-xs text-signal-ink tabular-nums"
						>
							{String(index + 1).padStart(2, "0")}
						</span>
						<span className="text-pretty">{item}</span>
					</li>
				))}
			</ol>
			{note ? (
				<p className="mt-6 text-sm text-pretty text-muted-foreground">{note}</p>
			) : null}
		</Reveal>
	);
}
